module.exports = __webpack_public_path__ + "static/media/supplier-number.34cb8acc.svg";